module.exports = __webpack_public_path__ + "static/media/amba.6b78c91a.png";